/* eslint-disable no-throw-literal */
import React from 'react';
import Button from 'material-ui/Button';

import {PERSONAL_BOOK_ADD, PRC_BOOK_ADD} from '../modules/user'

export const WRONG_READING_LEVEL = 'WRONG_READING_LEVEL';
export const TOO_MANY_CHOICE_BOOKS = 'TOO_MANY_CHOICE_BOOKS';
export const TOO_MANY_SERIES_BOOKS = 'TOO_MANY_SERIES_BOOKS';
export const TOO_MANY_SERIES_BOOKS_RECOVERABLE = 'TOO_MANY_SERIES_BOOKS_RECOVERABLE';
export const WRONG_READING_LEVEL_RECOVERABLE = 'WRONG_READING_LEVEL_RECOVERABLE';

const validateChoiceBook = (book, state, throwError = false) => {
    const allowedChoiceBooks = Number(state.student.readingRecord.maxChoiceBooks);
    const currentChoiceCount = state.user.personalBookList.length;

    if (currentChoiceCount >= allowedChoiceBooks) {
        if (throwError) throw {rule: TOO_MANY_CHOICE_BOOKS, book};
        else return false;
    }

    return true;
}

const validateBookSeriesCount = (book, state) => {
    if (!book.series) {
        return true;
    }
    const readingRecord = state.user.readList;
    const booksFromSameSeries = readingRecord.filter(existingBook => book.series === existingBook.series);

    // can read up to 5
    return booksFromSameSeries.length <= 4;
}

const validatePrcBook = (book, state) => {
    if (book.isOfficial === false || book.isOfficial === 'F') {
        const isValidChoiceBook = validateChoiceBook(book, state);
        if (isValidChoiceBook) {
            return {shouldTreatAsChoice: true};
        } else {
            throw {shouldTreatAsChoice: true, rule: TOO_MANY_CHOICE_BOOKS, book};
        }
    }

    const allowedLevels = state.student.readingRecord.readingLevels.split(',');

    if (!allowedLevels.includes(book.readingLevel)) {
        if (validateChoiceBook(book, state)) {
            throw {rule: WRONG_READING_LEVEL_RECOVERABLE, book};
        }

        throw {rule: WRONG_READING_LEVEL, book};
    }

    if (!validateBookSeriesCount(book, state)) {
        if (validateChoiceBook(book, state)) {
            throw {rule: TOO_MANY_SERIES_BOOKS_RECOVERABLE, book};
        }
        throw {rule: TOO_MANY_SERIES_BOOKS, book};
    }

    return true;
}

export default async (action, state) => {
    const book = action.payload;

    switch (action.type) {
        case PERSONAL_BOOK_ADD:
            return validateChoiceBook(book, state, true);
        case PRC_BOOK_ADD:
            return validatePrcBook(book, state);
        default:
            return true;
    }
}



const submitAsChoiceActions = (dialogCloseHandler, submitAsChoiceBook, book) => (
    <div>
        <Button
            type="label"
            onClick={dialogCloseHandler}
        >
            Cancel
        </Button>
        <Button
            type="primary"
            onClick={submitAsChoiceBook(book)}
        >
            Add as Personal Choice Book
        </Button>
    </div>
);

export const buildDialogContent = (errorInfo, dialogCloseHandler, submitAsChoiceBook, children) => {
    let errorTitle = 'Oops! Error encountered';
    let errorBody = <p>Keep calm and reload the page</p>;
    let errorActions = (
        <Button onClick={dialogCloseHandler}>
            Reload
        </Button>
    );

    const rule = errorInfo.rule || '';

    const errorClass = rule ?
        'rule-violation' :
        'errorBoundary';

    // for rule violations, don't hide backdrop content
    const backdropContent = rule ?
        children :
        <h4>Please refresh the page to continue</h4>;

    // if the error was recoverable, allow user to submit the book as choice book instead
    if (rule.includes('RECOVERABLE')) {
        errorActions = submitAsChoiceActions(dialogCloseHandler, submitAsChoiceBook, errorInfo.book);
    } else {
        // otherwise just show 'ok'
        errorActions = (
            <Button onClick={dialogCloseHandler}>
                Ok
            </Button>
        );
    }

    switch (rule) {
        case WRONG_READING_LEVEL:
        case WRONG_READING_LEVEL_RECOVERABLE:
            errorTitle = 'Oops! Book outside of Challenge Level'
            errorBody = (
                <div>
                    <p>This book is outside your challenge level, and the Challenge Rules don't allow you to add it as a PRC book unfortunately.</p>
                    {rule.includes('RECOVERABLE') && (
                        <div>
                            <p>However, if you have read this book you can add it as a Personal Choice book!</p>
                            <p>Simply choose "Add as Personal Choice Book" below to continue.</p>
                        </div>
                    )}
                    {!rule.includes('RECOVERABLE') && (
                        <div>
                            <p>
                                You can add PRC books from other Challenge Levels to your Personal Choice list, however you've already filled that up!
                            </p>
                            <p>
                                If you want to add this book, you will need to remove something from your Personal Choice list first.
                            </p>
                        </div>
                    )}
                </div>
            );
            break;
        case TOO_MANY_SERIES_BOOKS:
        case TOO_MANY_SERIES_BOOKS_RECOVERABLE:
            errorTitle = 'Oops! Only 5 books allowed from a series'
            errorBody = (
                <div>
                    <p>Well done, you must like this series a lot!</p>
                    <p>However, you can only record 5 books from a series as PRC books on your reading log.</p>
                    {rule.includes('RECOVERABLE') && (
                        <p>
                            You can still add this to your Personal Choice books list! Just select 'Add as Personal Choice book' below.
                        </p>
                    )}
                    {!rule.includes('RECOVERABLE') && (
                        <div>
                            <p>
                                You can keep adding PRC books from this series to your Personal Choice list, however you've already filled that up!
                            </p>
                            <p>
                                If you want to add this book, you will need to remove something from your Personal Choice list first.
                            </p>
                        </div>
                    )}
                </div>
            );
            break;

        case TOO_MANY_CHOICE_BOOKS:
            errorTitle = 'Oops! Only 10 Personal Choice books allowed';
            errorBody = (
                <div>
                    <p>
                        Nice, you seem to be adding lots of Personal Choice books. However, the challenge allows only for 10 Personal Choice books.
                    </p>
                    <p>
                        Give the PRC list a go, we have so many exciting books for you. So go on, discover PRC books from the home page!
                    </p>
                </div>
            );
            break;

        default:
            return {
                backdropContent,
                errorTitle,
                errorBody,
                errorActions,
            };
    }

    return {
        backdropContent,
        errorTitle,
        errorBody,
        errorActions,
        errorClass,
    };
}
